export default {
  title: 'Загрузка истории чата',
  modal: {
    title: 'Загрузка истории чата',
    description: 'Выберите, пожалуйста, временной промежуток. Все входящие и исходящие сообщения из всех чатов будут включены в отчёт.<br> Не закрывайте окно во время формирования отчёта.',
    from: 'От',
    to: 'Кому',
    btn_submit: 'Создать отчёт',
  },
  alert: {
    start: {
      title: 'Отчёт формируется',
    },
    end: {
      title: 'Отчёт готов!',
      description: 'Загрузите отчёт. Файл так же был добавлен в секцию Документы.',
    },
  },
}
